import React, { useState,memo, useCallback } from 'react';
import Results from './results/Results';
import Voc from './results/voc/Voc.js';
import Colloc from './results/colloc/Colloc.js';
import Meta from './results/meta/Meta.js';
import SpecialProgressBar from './results/SpecialProgressBar.js';
import { prepCoocSpec, prepStatsData, prepConcordData, prepReadyData, prepChronoData} from "./results/prepData";




const ResultTabItem=  memo( function ResultTabItem( {id,corpus,collections,session_id,results,status,resultType,completeSearch,pasteQuery,setResultInTab} ) {
  

    const [currentResultIndex,setCurrentResultIndex]=useState(0);
    const [resultsHistory,setResultsHistory]=useState([]);
    const [waitingQueryResult,setWaitingQueryResult]=useState(false);

    // on ajoute la props results à l'historique qui comporte tous les résultats enfants
    // et qui est inscrit dans l'état
    const fullResultsHistory=results ? [results,...resultsHistory] : resultsHistory;

    //console.log("status=",status,"Waiting=",waitingQueryResult);
    //console.log(results);
    
    // complete the result table
    const prepareResults = (results) => {
      results.corpusName=corpus.name.join(", ");
      results.coocSpec=prepCoocSpec(results);
      results.stats=prepStatsData(results);
      results.concords=prepConcordData(results);
      results.recap=prepReadyData(results);
      results.chronoData=prepChronoData(results);
    };

    const addResults = (res) => {
      // if the main results is not yet set, then call setResultInTab
      if (! results) {
        // when the first result is ready the setResultInTab will be fired and the component will rerender
        if (resultType==='results') {
          prepareResults(res);
        } else if (resultType==='meta')  {
          res.query="meta";
        }
        //results.corpusName=args.corpus ? args.corpus.name.join(", "):corpus.name.join(", ");
        //console.log("setResultInTab(id,res)",id,res);
        setResultInTab(id,res);
        setWaitingQueryResult(false);
      } else {
        // these are results that derives from the first results.
        // these results are stored in resultsHistory
        prepareResults(res);
        setResultsHistory([...resultsHistory,res]); // adding the new results in resultHistory
        setCurrentResultIndex(fullResultsHistory.length);
        setWaitingQueryResult(false);
      }
    }

    // Run the search endpoint and load the result in state var for a new query (using the same session_id)
    const performSearch = useCallback((args) => {
      const useCompleteSearch=args.useCompleteSearch? args.useCompleteSearch: completeSearch;
      const q= args.query? args.query: fullResultsHistory[currentResultIndex].query;
      const endpoint = '/search.ajax.php';
      const data = {
        query:q,
        session_id,
        completeSearch:useCompleteSearch,
        selectedSents:args.selectedSents
      };
      setWaitingQueryResult(true);

      //console.log("EndPoint: "+process.env.REACT_APP_API_BASE + endpoint + '?' + queryParams);
      fetch(
        process.env.REACT_APP_API_BASE + endpoint , {
          credentials: process.env.REACT_APP_CREDENTIALS,
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data),
        }
      )
      .then((res) => {
        if (res.status !== 200) {
          console.log(`Issue reaching ${endpoint}`);
          return;
        }
      })
    //},[completeSearch,resultsHistory,fullResultsHistory,session_id,currentResultIndex]);
    },[completeSearch,fullResultsHistory,session_id,currentResultIndex]);

    // Run MLM on server and add the new data to current session, to display a new tab
    const runMLM = useCallback(() => {
      // first step : creating a new query Session 
      const endpoint = '/run_MLM.ajax.php';
      const data= { sessionId:session_id};
      setWaitingQueryResult(true);
      fetch(
        process.env.REACT_APP_API_BASE + endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data),
        }
      )
      .then((res) => {
        if (res.status !== 200) {
          console.log(`Issue reaching ${endpoint}`);
          setWaitingQueryResult(false);
          return;
        }
      })
      .catch(() => {
        console.log(`Network eror when trying to fetch ${endpoint}`);
        setWaitingQueryResult(false);
      })
    },[session_id]);
    // },[resultsHistory,session_id,currentResultIndex]);

    // to handle the selection of an previous query in resultHistory
    const onSelectResult=(e) => {
      e.preventDefault();
      const { value } = e.target;
      if (value.match(/^(\d+)/)) {
        const index=parseInt(RegExp.$1);
        setCurrentResultIndex(index);
      }
     
    };

    const subCorpora=results ? 
      ((resultType==='voc')? Object.keys(results.lemma).filter(sub => sub!=='__global__').sort():
      ((resultType==='colloc')? Object.keys(results.colloc).filter(sub => sub!=='__global__').sort():[])):
      null;
    //console.log("renderResultTabItem",results.query);
    
    // memoization
    const memo_collections = React.useMemo(() => {
      return collections
    }, [collections]);

    const memo_results = React.useMemo(() => {
      return fullResultsHistory[currentResultIndex]
    }, [fullResultsHistory,currentResultIndex]);

    const queryHistory= fullResultsHistory.map( (res,index)=> index.toString()+" : "+res.query+" - "+results.corpusName );

    // conditionally display the components based on the progression of the user
    return (
      <>
          { (waitingQueryResult || status==="waiting") && 
            <SpecialProgressBar session_id={session_id} addResults={addResults}/>
          }
          { (!waitingQueryResult && status!=="waiting"  && (resultType === 'results' || currentResultIndex > 0 )) && 
              <Results
                collections={memo_collections}
                results={memo_results} 
                performSearch={performSearch} 
                pasteQuery={pasteQuery}
                runMLM={runMLM}
                onSelectResult={onSelectResult}
                currentResultIndex={currentResultIndex}
                queryHistory={queryHistory}
              />
          }
          { (! waitingQueryResult && status!=="waiting" && resultType === 'voc' && currentResultIndex === 0) &&           
              <Voc 
                  stats={results} 
                  subCorpora={subCorpora} 
                  performSearch={performSearch}
                  session_id={session_id}
                  queryHistory={queryHistory}
                  onSelectResult={onSelectResult}
                  language={corpus.language}
              /> 
          }
          {   (! waitingQueryResult && status!=="waiting" && resultType === 'colloc' && currentResultIndex === 0) &&  
              <Colloc 
                  stats={results} 
                  subCorpora={subCorpora} 
                  performSearch={performSearch}
                  queryHistory={queryHistory}
                  onSelectResult={onSelectResult}
              />
          }
          {  ( resultType === 'meta' && results ) &&
             <Meta data={results} />
          }
      </>
    );
},areEqual);

function areEqual(prevProps, nextProps) {
  if (prevProps.results===nextProps.results) {
    return true;
  } else {
    return false;
  }
}

export default ResultTabItem;
